











































































































import { Component, Vue } from 'vue-property-decorator'
import Tabs from '@/components/Tabs/index.vue'
import { BaseStore, LettersType } from '@/store/modules/Base'
import { listLetters, markReadLetters, deleteLetters, typeSiteMail } from '@/api/com'

import { GetDateTY, formatDate } from '@/utils/tool'

interface dateType {
  name: string;
  list: any[]
}

@Component({
  // 所有的组件选项都可以放在这里
  name: 'Message',
  components: {
    Tabs
  }
})
export default class Message extends Vue {
  formatDate = formatDate

  get letters (): LettersType {
    return BaseStore.letters
  }

  // 多选选中的值ID
  checkedCities:number[] = []

  checkAll = false

  isIndeterminate = false

  private form = {
    date: [],
    keywords: ''
  }

  private dialogVisible = false

  private dialogData:any = {}

  get tabList () {
    let str = ''
    if (this.letters.notReadNum) {
      str = '(' + this.letters.notReadNum + ')'
    }
    return [
      { name: `未读消息${str}`, id: 1 },
      { name: '已读消息', id: 2 },
      { name: '删除消息', id: 3 },
      { name: '全部消息', id: 99 }
    ]
  }

  tableList: Array<dateType> = []

  //  1-未读 2-已读 3-删除 空为全部
  state = 1

  page = 1

  resultNum = 10

  // 总条数
  sizeAll = 0

  // 总页数
  pageCount = 0

  // 列表所有选项ID集合
  allIdList: number[] = []

  // 通知类型
  msgType = {}

  // 通知类型图标
  msgTypeIcon = {}

  // 选择日期
  handleChangeDate (value: string[]): void {
    console.log(value)
    this.getListLetters()
  }

  // 切换当前页码
  handleCurrentChange (val: number): void {
    this.page = val
    this.getListLetters()
  }

  // 切换Tab
  changeTabsItem (item): void {
    this.state = item
    this.getListLetters()
    this.checkedCities = []
    this.checkAll = false
  }

  handleChecked (value: string[]):void {
    console.log(value, '选中的checkbox值')
  }

  // 重置
  resetForm () {
    this.form = {
      date: [],
      keywords: ''
    }
    this.getListLetters()
  }

  handleCheckAllChange (val: number[]): void {
    this.checkedCities = val ? this.allIdList : []
    this.isIndeterminate = false
  }

  beforeClose (done) {
    (this.$refs as any).dialogCon.scrollTop = 0
    this.setMarkReadLetters(this.dialogData.id)
    done()
  }

  handleCloseBtn () {
    (this.$refs as any).dialogCon.scrollTop = 0
    this.setMarkReadLetters(this.dialogData.id)
    this.dialogVisible = false
  }

  dialogDelete (id) {
    this.dialogVisible = false
    this.setDeleteLetters(id)
  }

  // 标记已读
  setMarkReadLetters (ids: string) {
    const params = {
      ids: ids
    }
    markReadLetters(params)
      .then(res => {
        if (res.success) {
          this.getListLetters()
          BaseStore.API_COUNT_LETTERS()
        }
      })
  }

  // 删除
  setDeleteLetters (ids: string) {
    deleteLetters({
      ids
    })
      .then(res => {
        if (res.success) {
          this.getListLetters()
        }
      })
  }

  // 获取站内心列表
  getListLetters () {
    const params = {
      keywords: this.form.keywords,
      startDate: this.form.date[0] || '',
      endDate: this.form.date[1] || '',
      page: this.page,
      resultNum: this.resultNum,
      state: this.state === 99 ? '' : this.state
    }
    listLetters(params)
      .then(res => {
        // console.log(res)
        if (res) {
          this.sizeAll = res.sizeAll
          this.pageCount = res.pageCount
          this.handleLetters(res.results || [])
        }
      })
  }

  // 处理下数据 今天 昨天 更早
  handleLetters (results) {
    if (results.length === 0) this.tableList = []
    const arr: Array<dateType> = []
    // 今天
    const today: dateType = {
      name: '今天',
      list: []
    }
    // 昨天
    const yesterday: dateType = {
      name: '昨天',
      list: []
    }
    // 更早
    const beYesterday: dateType = {
      name: '更早',
      list: []
    }
    for (let i = 0; i < results.length; i++) {
      const item: any = results[i]
      const num = GetDateTY(item.sendDate)
      this.allIdList.push(item.id)
      this.allIdList = Array.from(new Set(this.allIdList))
      if (num === 0) {
        today.list.push(item)
      } else if (num === -1) {
        yesterday.list.push(item)
      } else if (num === -2) {
        beYesterday.list.push(item)
      }
    }
    if (today.list.length) arr.push(today)
    if (yesterday.list.length) arr.push(yesterday)
    if (beYesterday.list.length) arr.push(beYesterday)
    this.tableList = arr
  }

  // 点击了某一天信息
  clickMsg (item) {
    // console.log(item)
    this.dialogData = item
    this.dialogVisible = true
  }

  // 获取站内信通知类型枚举
  getTypeSiteMail () {
    typeSiteMail().then(res => {
      console.log(res, '获取站内信通知类型枚举')
      if (res) {
        res.map(item => {
          this.msgType[item.value] = item.label
          this.msgTypeIcon[item.value] = item.logo
        })
      }
    })
  }

  mounted (): void {
    this.getTypeSiteMail()
    this.getListLetters()
  }
}

